/**
 * 목록·상세가 **불러오는 중 / 비었음 / 실패**를 같은 모양으로 말하게 한다.
 *
 * ⚠ **화면마다 따로 쓰면 세 가지가 조금씩 달라진다.** 어떤 화면은 실패를 빈
 * 목록처럼 보여 주고, 어떤 화면은 「없음」을 안 그려서 사람이 계속 기다린다.
 * 특히 **빈 목록과 실패를 같게 그리는 것**이 가장 나쁘다 — 「오늘은 조용했나 보다」로
 * 읽히기 때문이다.
 */
import type { ReactNode } from 'react'
import { errorMessage } from '@/api/errors'
import { Notice } from './ui'

interface Props {
  isPending: boolean
  error: unknown
  /** 비어 있는가. 목록은 rows.length === 0, 상세는 보통 넘기지 않는다. */
  empty?: boolean
  emptyText?: string
  children: ReactNode
}

export function QueryState({ isPending, error, empty, emptyText, children }: Props) {
  if (isPending) {
    return <p className="py-6 text-center text-sm text-slate-500">Loading…</p>
  }

  if (error) {
    // ⚠ 401·pin_required·setup_required 는 여기까지 오지 않는다 — 앱 차원에서 이미
    // 가로챈다. 그래도 그물을 쳐 둔다: 가로채기가 깨져도 사람이 무슨 일인지는 알아야
    // 한다. 문구는 명세 4-4 가 기준이고, 표에 없는 code 는 서버 문구를 보인다.
    return <Notice tone="stop">{errorMessage(error)}</Notice>
  }

  if (empty) {
    return (
      <p className="py-6 text-center text-sm text-slate-500">
        {emptyText ?? 'No matching records.'}
      </p>
    )
  }

  return <>{children}</>
}
